import { reportError } from "./errors";
import { initialize } from "./initialize";
import { useSetMetaData } from "./metadata";

export const GrafanaFaro = {
  initialize,
  useSetMetaData,
  reportError,
};
